import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[app-insights-library__item-selector__item-actions]',
  standalone: false
})
export class InsightsLibraryItemSelectorItemActionsDirective {
  constructor(public readonly templateRef: TemplateRef<unknown>) {
  }
}
